import { format } from "date-fns";

export function getOpenNowLocation(businessHours: any): any {
    const weekDays: string[] = [
        'sunHours',
        'monHours',
        'tueHours',
        'wedHours',
        'thuHours',
        'friHours',
        'satHours'
      ];
    const dayNum: number = new Date().getDay();
    const weekDay = weekDays[dayNum];
    const [openingTime, closingTime] = businessHours && businessHours[weekDay]
      .split('-')
      .map((hour: string) => hour.trim())
      .map((hour: string) => {
        const date:Date = new Date()
        const currentDate = format(date, 'yyyy/MM/dd');
        return new Date(currentDate + ' ' + hour);
      });

    // return { openingTime, closingTime, currTime: new Date() };
    const currTime = new Date();

    return (currTime > openingTime && closingTime > currTime) 
}

export const mockLocationData = {
  radius: 5,
  locations: [
    {
      locationDetails: {
        name: "CVS01 - #10361",
        locationId: "68879480",
        kioskId: "MP00021865",
        addressLine1: "12027 TOWN SQUARE ST",
        addressLine2: "",
        addressLine3: "",
        city: "RESTON",
        state: "VA",
        country: "US",
        postalCode: "20190-6025",
        retailerId: "291060876",
        pwc: "0",
        distance: 0.8140946806421624,
        distanceuom: "mile",
        latitude: 38.958,
        longitude: -77.3614,
        bankAccountRequired: false,
        mainOfficeId: "65887048"
      },
      locationOperatingHours: {
        monHours: "08:00 AM - 10:00 PM",
        tueHours: "08:00 AM - 10:00 PM",
        wedHours: "08:00 AM - 12:00 PM",
        thuHours: "08:00 AM - 10:00 PM",
        friHours: "08:00 AM - 10:00 PM",
        satHours: "08:00 AM - 10:00 PM",
        sunHours: "09:00 AM - 09:00 PM"
      },
      locationPhone: {
        addToPhone: true,
        phone: "(703) 707-9787"
      },
      locationServices: {
        amazonCard: false,
        sendMoney: true,
        receiveMoney: true,
        billPayment: true,
        reloadOtherCard: false,
        addToPhone: true,
        payPal: false,
        moneyOrder: true,
        recCurrencies: "USD",
        sendCurrencies: "USD",
        xpressPackage: false,
        purchaseMoneygramCard: false,
        reloadMoneygramCard: false,
        receiveToCard: false,
        expressPayment: true,
        payWithCash: true,
        formFreeCompletion: true,
        directToAccount: false
      },
      locationAnalytics: {
        score: 1,
        feedback: {
          thumbsUp: 23,
          thumbsDown: 9
        },
      }
    },
    {
      locationDetails: {
        name: "CVS02 - #10361",
        locationId: "68879480",
        kioskId: "MP00021865",
        addressLine1: "12027 TOWN SQUARE ST",
        addressLine2: "",
        addressLine3: "",
        city: "RESTON",
        state: "VA",
        country: "US",
        postalCode: "20190-6025",
        retailerId: "291060876",
        pwc: "0",
        distance: 1.2140946806421624,
        distanceuom: "mile",
        latitude: 38.958,
        longitude: -77.3614,
        bankAccountRequired: false,
        mainOfficeId: "65887048"
      },
      locationOperatingHours: {
        monHours: "08:00 AM - 10:00 PM",
        tueHours: "08:00 AM - 10:00 PM",
        wedHours: "08:00 AM - 10:00 PM",
        thuHours: "08:00 AM - 10:00 PM",
        friHours: "08:00 AM - 10:00 PM",
        satHours: "08:00 AM - 10:00 PM",
        sunHours: "09:00 AM - 09:00 PM"
      },
      locationPhone: {
        addToPhone: true,
        phone: "(703) 707-9787"
      },
      locationServices: {
        amazonCard: false,
        sendMoney: true,
        receiveMoney: true,
        billPayment: true,
        reloadOtherCard: false,
        addToPhone: true,
        payPal: false,
        moneyOrder: true,
        recCurrencies: "USD",
        sendCurrencies: "USD",
        xpressPackage: false,
        purchaseMoneygramCard: false,
        reloadMoneygramCard: false,
        receiveToCard: false,
        expressPayment: true,
        payWithCash: true,
        formFreeCompletion: true,
        directToAccount: false
      },
      locationAnalytics: {
        score: 3,
        feedback: {
          thumbsUp: 23,
          thumbsDown: 9
        },
      }
    },
    {
      locationDetails: {
        name: "CVS01 - #10361",
        locationId: "68879480",
        kioskId: "MP00021865",
        addressLine1: "12027 TOWN SQUARE ST",
        addressLine2: "",
        addressLine3: "",
        city: "RESTON",
        state: "VA",
        country: "US",
        postalCode: "20190-6025",
        retailerId: "291060876",
        pwc: "0",
        distance: 0.940946806421624,
        distanceuom: "mile",
        latitude: 38.958,
        longitude: -77.3614,
        bankAccountRequired: false,
        mainOfficeId: "65887048"
      },
      locationOperatingHours: {
        monHours: "08:00 AM - 10:00 AM",
        tueHours: "08:00 AM - 10:00 PM",
        wedHours: "08:00 AM - 10:00 PM",
        thuHours: "08:00 AM - 10:00 PM",
        friHours: "08:00 AM - 10:00 PM",
        satHours: "08:00 AM - 10:00 PM",
        sunHours: "09:00 AM - 09:00 PM"
      },
      locationPhone: {
        addToPhone: true,
        phone: "(703) 707-9787"
      },
      locationServices: {
        amazonCard: false,
        sendMoney: true,
        receiveMoney: true,
        billPayment: true,
        reloadOtherCard: false,
        addToPhone: true,
        payPal: false,
        moneyOrder: true,
        recCurrencies: "USD",
        sendCurrencies: "USD",
        xpressPackage: false,
        purchaseMoneygramCard: false,
        reloadMoneygramCard: false,
        receiveToCard: false,
        expressPayment: true,
        payWithCash: true,
        formFreeCompletion: true,
        directToAccount: false
      },
      locationAnalytics: {
        score: 2,
        feedback: {
          thumbsUp: 23,
          thumbsDown: 9
        },
      }
    },
    
  ]
}

export function filterAndSortLocations(
  filters: string[],
  results: any,
  labels: any,
  flow: string
): any {
  const sdfLabels = labels?.locationMaps ? labels : labels?.labels?.stellar?.sdfcard;
  if (!filters || filters.length === 0) {
    filters = [sdfLabels?.locationMaps?.popular];
  }
  if (!results || results.length === 0 || !results?.locations || !results?.locations.length) {
    return null;
  }
  if (filters?.length > 0 && results) {
    let locations = results.locations;

    let popularIndex = filters.indexOf(sdfLabels?.locationMaps?.popular);
    let nearByIndex = filters.indexOf(sdfLabels?.locationMaps?.nearby);
    const openNowIndex = filters.indexOf(sdfLabels?.locationMaps?.openNow)

    if (popularIndex >= 0 && nearByIndex >= 0) {
      const lastSelectedFilter = filters[filters.length - 1];
      if (lastSelectedFilter === sdfLabels?.locationMaps?.popular) {
        nearByIndex = -1;
      } else if (lastSelectedFilter === sdfLabels?.locationMaps?.nearby) {
        popularIndex = -1;
      }
    }

    if (openNowIndex >= 0) {
      locations = locations.filter((location: any) =>
        getOpenNowLocation(location?.locationOperatingHours)
      );
    }

    if (nearByIndex >= 0) {
      locations = [...locations].sort((a: any, b: any) => {
        if (a.locationDetails?.distance !== b.locationDetails?.distance) {
          return a.locationDetails?.distance - b.locationDetails?.distance;
        } else {
          const scoreA =
            flow === 'deposit'
              ? a.locationAnalytics?.cashInOverallScore
              : a.locationAnalytics?.cashOutOverallScore;
          const scoreB =
            flow === 'deposit'
              ? b.locationAnalytics?.cashInOverallScore
              : b.locationAnalytics?.cashOutOverallScore;
          return scoreB - scoreA;
        }
      });
    } else if (popularIndex >= 0) {
      locations = [...locations].sort((a: any, b: any) => {
        const scoreA =
          flow === 'deposit'
            ? a.locationAnalytics?.cashInOverallScore
            : a.locationAnalytics?.cashOutOverallScore;
        const scoreB =
          flow === 'deposit'
            ? b.locationAnalytics?.cashInOverallScore
            : b.locationAnalytics?.cashOutOverallScore;
        if (scoreA !== scoreB) {
          return scoreB - scoreA;
        } else {
          const distanceA = a.locationDetails?.distance;
          const distanceB = b.locationDetails?.distance;
          return distanceA - distanceB;
        }
      });
    }
    const res = { ...results, locations };
    return res;
  }
}
